
<div :class="jel_getClassObject(content)">
  <b-form-checkbox v-model="recevoirCommunication" :name="content.libRecevoirCommunication">
    <span class="font-weight-normal" v-html="content.libRecevoirCommunication" />
  </b-form-checkbox>
</div>
